import { render, staticRenderFns } from "./MobileManual.vue?vue&type=template&id=b7395482&scoped=true"
import script from "./MobileManual.vue?vue&type=script&lang=js"
export * from "./MobileManual.vue?vue&type=script&lang=js"
import style0 from "./MobileManual.vue?vue&type=style&index=0&id=b7395482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7395482",
  null
  
)

export default component.exports